import React from 'react';
import { Tray } from '../../../components/elements';
import { ISurveyTemplateElementData } from '../../../components/Surveys/ISurveyTemplateElementData';

export function SurveyEditAoBasisgegevensElement(
    _props: { surveyId: string; objectId: string; onItemChanged: () => Promise<void> } & ISurveyTemplateElementData,
) {
    return <Tray>&nbsp;</Tray>;
}
